<div>
  <form>

    <!-- Text area -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'addcomment' | translate }}</mat-label>
      <textarea matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="4"
        [(ngModel)]="comment"
        [ngModelOptions]="{ standalone: true }">
      </textarea>
    </mat-form-field>
  
    <!-- Submit -->
    <div class="submit-field">
      <button mat-flat-button type="button" color="primary" (click)="submit()">
        {{ 'send' | translate }}
      </button>
    </div>
    
  </form>
</div>